import { type AssetHoldingPortfolio } from '../schema-dtos/DashboardDomainDtos'
import { type AssetHolderIdProps } from './assetHolderApi'

export const assetHolderApiMapper = (): any => {
  const dashboardMapper = (responseData: AssetHoldingPortfolio, meta: any, args: AssetHolderIdProps): AssetHoldingPortfolio => {
    return responseData
  }

  return {
    dashboardMapper
  }
}
